"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var DefaultButton_1 = require("../../../../common/components/presentation/Buttons/DefaultButton");
var FinanceCalculatorContainer_1 = require("../../../../common/components/financeCalculator/FinanceCalculatorContainer");
var useCheckoutContext_1 = require("../../../../gql/common/hooks/useCheckoutContext");
var ContinueButton_1 = require("../buttons/continueButton/ContinueButton");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var headlessFinanceSectionStyles_1 = require("./headlessFinanceSectionStyles");
var HeadlessFinanceSection = function () {
    var _a;
    var styles = headlessFinanceSectionStyles_1.default();
    var deal = useCheckoutContext_1.default().deal;
    var _b = react_1.useState(false), isFincalcOpen = _b[0], setIsFincalcOpen = _b[1];
    var toggleFinanceCalculator = react_1.useCallback(function (shouldOpen) { return setIsFincalcOpen(shouldOpen); }, [setIsFincalcOpen]);
    return (<core_1.Box data-test={'checkout:headless_finance_section'} className={styles.financeWrapper}>
      <core_1.Typography className={styles.title}>
        <Translation_1.default id="trans__checkout__next_step__payment_method_section_title"/>
      </core_1.Typography>
      <core_1.Typography className={styles.description}>
        <Translation_1.default id="trans__checkout__next_step__payment_method_section_description"/>
      </core_1.Typography>
      <core_1.Box data-test={'checkout:headless_finance_section_actions'}>
        <ContinueButton_1.default testId="checkout:continue_button:headless_finance" activateNextStep={true}/>
        <DefaultButton_1.default className={[styles.buttonContainer]} onClick={function () { return setIsFincalcOpen(true); }} dataTest="checkout:headless_finance_section:button" variant="outlined">
          <Translation_1.default id="trans__checkout__next_step__payment_method_section_review_payment_option_CTA"/>
        </DefaultButton_1.default>
      </core_1.Box>
      <FinanceCalculatorContainer_1.default isModalOpen={isFincalcOpen} toggleModal={toggleFinanceCalculator} carConfiguration={(_a = deal.car) === null || _a === void 0 ? void 0 : _a.code}/>
    </core_1.Box>);
};
exports.default = HeadlessFinanceSection;
